import fetch from './fetch'

// 公共的图片接口
// 批量删除图片
export function delPictureByIds(ids) {
  const data = {
    ids,
    _method: 'delete',
  }
  return fetch({
    url: '/coroutine/picture/file/remove',
    method: 'post',
    data,
  })
}

// 获取相册分类列表
export function getAlbumCategory() {
  return fetch({
    url: '/coroutine/picture/category/lists',
    method: 'get',
  })
}

// 相册分类删除
export function delAlbumCategoryById(id) {
  return fetch({
    url: '/coroutine/picture/category/remove',
    method: 'delete',
    params: { id },
  })
}

// 相册分类添加
export function addAlbumCategory(pid, name) {
  const data = {
    pid,
    name,
  }
  return fetch({
    url: '/coroutine/picture/category/create',
    method: 'post',
    data,
  })
}

// 相册分类名称修改
export function editAlbumCategoryById(id, name) {
  const data = {
    id,
    name,
  }
  return fetch({
    url: '/coroutine/picture/category/editor',
    method: 'post',
    data,
  })
}

// 获取相册列表
export function getPictureList(data) {
  return fetch({
    url: '/coroutine/picture/file/lists',
    method: 'get',
    params: data,
  })
}

// 保存图片信息
export function editAlbumById(id, name, description) {
  const data = {
    id,
    name,
    description,
  }
  return fetch({
    url: '/coroutine/picture/file/desc',
    method: 'post',
    data,
  })
}

// 上传图片
export function uploadImage(formData) {
  return fetch({
    url: '/coroutine/picture/file/upload',
    method: 'POST',
    data: formData,
  })
}
